import React from "react";
import { resolveImage } from "../lib/api";

/**
 * Holographic Placeholder
 * - If imageUrl is provided, renders the image inside the holo frame
 * - Else shows the pure CSS foil-shimmer with watermark
 */
export default function HolographicPlaceholder({
  label = "KAVO",
  subLabel,
  ratio = "aspect-[3/4]",
  imageUrl,
  className = "",
  testId,
}) {
  const initials = (label || "")
    .split(/[\s—-]+/)
    .filter(Boolean)
    .slice(0, 3)
    .map((w) => w[0]?.toUpperCase())
    .join("");

  const src = resolveImage(imageUrl);

  if (src) {
    return (
      <div
        data-testid={testId}
        className={`relative ${ratio} w-full rounded-xl overflow-hidden border border-white/5 bg-[#0A0812] ${className}`}
      >
        <img
          src={src}
          alt={label}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      data-testid={testId}
      className={`holo grain ${ratio} w-full rounded-xl flex items-center justify-center select-none ${className}`}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="font-display font-extrabold tracking-[0.25em] text-[10vw] sm:text-[3.5rem] leading-none text-white/[0.06]">
          KAVO
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-display font-extrabold text-2xl sm:text-3xl text-white/80">
            {initials || "KC"}
          </div>
          {subLabel ? (
            <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-white/40 font-mono">
              {subLabel}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
